// extracted by mini-css-extract-plugin
export default {"wrapper":"textArea_wrapper__PPJJw","active":"textArea_active__YPgGx","count":"textArea_count__XWJ7w"};